import { selectFlags } from '../data-layer/experiments/selectors';
import { useSelector } from '../data-layer/useSelector';

export const useExperimentFlag = (name: string) => {
    const flags = useSelector((state) => selectFlags(state));

    return flags ? flags[name] : undefined;
};
